const codes = [
  {
    param: 'utm_source',
    key: 'source',
  },
  {
    param: 'utm_medium',
    key: 'medium',
  },
  {
    param: 'utm_bp',
    key: 'bp',
  },
  {
    param: 'utm_campaign',
    key: 'campaign',
  },
  {
    param: 'utm_content',
    key: 'content',
  },
  {
    param: 'ruleId',
    key: 'ruleId',
  },
  {
    param: 'userChoseDates',
    key: 'userChoseDates',
  },
  {
    param: 'utm_term',
    key: 'term',
  },
  {
    param: 'utm_ad',
    key: 'ad',
  },
  {
    param: 'utm_adgroup',
    key: 'adgroup',
  },
  {
    param: 'utm_fb',
    key: 'fb',
  },
  {
    param: 'utm_google',
    key: 'google',
  },
  {
    param: 'utm_join',
    key: 'join',
  },
  {
    param: 'utm_tl',
    key: 'tl',
  },
  {
    param: 'utm_store_join',
    key: 'store_join',
  },
  {
    param: 'gclid',
    key: 'gclid',
  },
  {
    param: 'fbclid',
    key: 'fbclid',
  },
  {
    param: 'irclickid',
    key: 'irclickid',
  },
  {
    param: 'r',
    key: 'r',
  },
  {
    param: 'sid',
    key: 'sid',
  },
]

/** Query params in this set keep original casing (identifiers may be case-sensitive). */
const preserveCaseParams = new Set(['utm_tl', 'r', 'sid', 'ruleId'])

export function toUtmParams(utm: App.UTMState) {
  return codes.reduce<Record<string, string>>((accumulator, currentValue) => {
    const value = utm[currentValue.key]
    if (value) {
      accumulator[currentValue.param] = value
    }
    return accumulator
  }, {})
}

export default function utmCodes(
  query: { [param: string]: any },
): App.UTMState {
  return codes.reduce<Record<string, string>>((accumulator, currentValue) => {
    const param = query[currentValue.param]
    const processParam = (param: string) =>
      preserveCaseParams.has(currentValue.param) ? param : param.toLowerCase()

    if (param) {
      if (param instanceof Array) {
        accumulator[currentValue.key] = processParam(param[0])
      } else {
        accumulator[currentValue.key] = processParam(param)
      }
    }
    return accumulator
  }, {})
}
